import Axios from "axios";
import QueryOptions from "../sal-ui/QueryOptions";
import PagedResult from "./PagedResult";
import ExternalSearchPricing from "../domain/ExternalSearchPricing";

class ExternalSearchPricingService {

    readonly basePath = "/external-search-pricings";

    public add(pricing: ExternalSearchPricing): Promise<string> {
        return Axios.post(`${this.basePath}`, pricing).then(value => value.data.id);
    }

    public update(id: string, pricing: ExternalSearchPricing): Promise<void> {
        return Axios.put(`${this.basePath}/${id}`, pricing);
    }

    public get(id: string): Promise<ExternalSearchPricing> {
        return Axios.get(`${this.basePath}/${id}`)
            .then(value => ExternalSearchPricing.fromPOJO(value.data));
    }

    public delete(pricing: ExternalSearchPricing): Promise<void> {
        return Axios.delete(`${this.basePath}/${pricing.id}`);
    }

    public getList(queryOptions: QueryOptions): Promise<PagedResult<ExternalSearchPricing>> {
        return Axios.get(`${this.basePath}?${queryOptions.toQueryParams()}`)
            .then(value => new PagedResult(
                value.data.total,
                value.data.data.map((item: object) => ExternalSearchPricing.fromPOJO(item))
            ));
    }
}

export default ExternalSearchPricingService;
